export function idArrayToRecord<T extends { id: number }>(tArray: T[]): Record<number, T> {
  if (!tArray) {
    return {};
  }
  return tArray.reduce((record: Record<number, T>, t: T) => {
    record[t.id] = t;
    return record;
  }, {});
}
